(ns manatee.sysadmin.import-tasks
  (:require
   [rothko.panel.component :refer [panel]]))

(defn view
  []
  [:<>
   [panel {:appearance #{:primary}
           :class      [:admin-page__panel]}
    [:span "*Not yet implemented*"]]])
